<template>
  <layout title="Courses">
    <div class="row">
      <div class="col-10">
        <h2 class="page-heading">
          <inertia-link
            class="previous-path-header"
            :href="route('courses.index')"
          >
            Courses
          </inertia-link>
          / Create
        </h2>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="card shadow-sm p-3 mb-5 bg-white rounded mt-2">
          <div class="card-body col-md-8">
            <form @submit.prevent="create">
              <div class="form-group row">
                <label for="name" class="col-sm-2 col-form-label">Name</label>
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    id="name"
                    placeholder=""
                    v-model="form.name"
                  />
                  <div v-if="errors && errors.name" class="d-block invalid-feedback">
                    {{ errors.name }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="name" class="col-sm-2 col-form-label">
                  Description
                </label>
                <div class="col-sm-10">
                  <textarea
                    class="form-control"
                    id="description"
                    rows="5"
                    v-model="form.description"
                  />
                   <div v-if="errors && errors.description" class="d-block invalid-feedback">
                    {{ errors.description }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-12">
                  <button type="submit" class="btn btn-primary float-right">
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import AppLayout from "../Layouts/AppLayout";

export default {
  layout: AppLayout,
  props: {
    errors: Object,
  },
  data() {
    return {
      form: {
        name: "",
        description: "",
      },
    };
  },
  methods: {
    create() {
      this.$inertia.post(route("courses.store"), this.form);
    },
  },
};
</script>
